// Copyright © 2025 CATTLEytics Inc.

import { Stack } from 'react-bootstrap';

import Button from '../../common/components/Button';
import { exportPivotTableToCSV } from './csvExport';
import { PivotTable } from './PivotTable';

export function SoldAnimalsPivot({ data }: { data: any[] }): JSX.Element {
  // Determine the field names based on the data structure
  const sampleRow = data[0] || {};
  const columns = Object.keys(sampleRow);

  // For Sold Animals, we want months as rows and event types as columns
  let rowField = 'month';
  let columnField = 'eventtype';
  let valueField = 'SUM(count_events)';

  // Try to detect the correct field names
  const possibleMonthFields = columns.filter(
    (col) =>
      col.toLowerCase().includes('month') ||
      col.toLowerCase().includes('date') ||
      col.toLowerCase().includes('period'),
  );
  const possibleEventFields = columns.filter(
    (col) =>
      col.toLowerCase().includes('event') ||
      col.toLowerCase().includes('type') ||
      col.toLowerCase().includes('category'),
  );
  const possibleValueFields = columns.filter(
    (col) =>
      col.toLowerCase().includes('count') ||
      col.toLowerCase().includes('sum') ||
      col.toLowerCase().includes('total') ||
      col.toLowerCase().includes('value'),
  );

  if (possibleMonthFields.length > 0) {
    rowField = possibleMonthFields[0];
  }
  if (possibleEventFields.length > 0) {
    columnField = possibleEventFields[0];
  }
  if (possibleValueFields.length > 0) {
    valueField = possibleValueFields[0];
  }

  return (
    <>
      <Button
        onClick={(): void => {
          const timestamp = new Date().toISOString().split('T')[0];
          exportPivotTableToCSV(
            data,
            rowField,
            columnField,
            valueField,
            `Sold_Animals_${timestamp}`,
            true, // showRowTotals
            false,
          );
        }}
      >
        Export to CSV
      </Button>
      <Stack gap={3}>
        <PivotTable
          aggregateFunction={(values): string => {
            const sum = values.reduce((acc, val) => acc + (Number(val) || 0), 0);
            return sum > 0 ? sum : '';
          }}
          columnField={columnField}
          data={data}
          rowField={rowField}
          showRowTotals={true}
          valueField={valueField}
        />
      </Stack>
    </>
  );
}
